/**
 * Product Card Quantity Selector and Add to Cart
 * Handles quantity buttons and add to cart functionality for product cards
 */

(function() {
  'use strict';

  // Quantity +/- buttons handler
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('plus') || e.target.classList.contains('minus')) {
      const wrapper = e.target.closest('.card-qty-wrapper');
      if (!wrapper) return;
      
      const input = wrapper.querySelector('.card-qty-input');
      if (!input) return;
      
      const min = parseInt(input.min) || 1;
      const max = input.max ? parseInt(input.max) : null;
      const step = parseInt(input.step) || 1;
      let value = parseInt(input.value) || min;

      if (e.target.classList.contains('plus')) {
        value += step;
        if (max && value > max) value = max;
      } else if (e.target.classList.contains('minus')) {
        value -= step;
        if (value < min) value = min;
      }

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Color swatch selection (no redirect)
  // - Sets the closest product form's variant id input to the swatch's variant id
  // - Toggles active state
  // - Updates product image to show selected variant's image
  document.addEventListener('click', function(e) {
    const swatchBtn = e.target.closest('.card__color-swatch');
    if (!swatchBtn) return;

    const variantId = swatchBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Toggle active state within this swatch group
    const swatchGroup = swatchBtn.closest('.card__color-swatches');
    if (swatchGroup) {
      swatchGroup.querySelectorAll('.card__color-swatch').forEach((btn) => {
        btn.classList.toggle('card__color-swatch--active', btn === swatchBtn);
      });
    }

    // Update nearest product form variant input
    const card = swatchBtn.closest('.card-wrapper, .product-card-wrapper');
    if (!card) return;

    const form = card.querySelector('product-form form') || card.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Update product image if variant image data is available
    const variantImageSrcset = swatchBtn.getAttribute('data-variant-image-srcset');
    const variantImageSrc = swatchBtn.getAttribute('data-variant-image-src');
    const colorName = swatchBtn.getAttribute('data-color-name');
    
    // Try multiple selectors to find the product image
    const productImage = card.querySelector('.card__product-image') || 
                         card.querySelector('.card__media img') || 
                         card.querySelector('.media img');
    
    if (productImage) {
      if (variantImageSrcset && variantImageSrc) {
        // Update image srcset and src
        productImage.setAttribute('srcset', variantImageSrcset);
        productImage.setAttribute('src', variantImageSrc);
        // Force browser to reload the image
        productImage.style.opacity = '0.9';
        setTimeout(() => {
          productImage.style.opacity = '1';
        }, 50);
      } else {
        // Debug: log when variant image is missing
        console.log('Variant image missing for color:', colorName, 'Variant ID:', variantId);
        if (productImage.hasAttribute('data-default-srcset')) {
          // Reset to default image if no variant image
          productImage.setAttribute('srcset', productImage.getAttribute('data-default-srcset'));
          productImage.setAttribute('src', productImage.getAttribute('data-default-src'));
        }
      }
    } else {
      console.log('Product image element not found in card');
    }
  });

})();
